import React from "react";
import { Link } from "react-router-dom";
import {
  RiAddLine,
  RiEdit2Line,
  RiDeleteBin6Line,
} from "react-icons/ri";

export const RoleListLayer = () => {
  // STATIC ROLE DATA
  const roles = [
    {
      id: 1,
      role_name: "Admin",
      description: "Full system access",
      status: "active",
    },
    {
      id: 2,
      role_name: "TM Leader",
      description: "Manage own team & reports",
      status: "active",
    },
    {
      id: 3,
      role_name: "Sales Executive",
      description: "Handle assigned leads & calls",
      status: "inactive",
    },
  ];

  const handleDelete = (id) => {
    alert(`Delete clicked for role id: ${id}`);
  };

  return (
    <div className="card">
      {/* HEADER */}
      <div className="card-header d-flex justify-content-between align-items-center">
        <h5 className="mb-0">Role Management</h5>
        <Link to="/roles/create" className="btn btn-primary btn-sm">
          <RiAddLine /> Add Role
        </Link>
      </div>

      {/* TABLE */}
      <div className="card-body">
        <div className="table-responsive">
          <table className="table table-bordered table-hover">
            <thead className="table-light">
              <tr>
                <th width="60">#</th>
                <th>Role Name</th>
                <th>Description</th>
                <th width="120">Status</th>
                <th width="140">Action</th>
              </tr>
            </thead>
            <tbody>
              {roles.length === 0 ? (
                <tr>
                  <td colSpan="5" className="text-center">
                  No roles found
                  </td>
                </tr>
              ) : (
                roles.map((role, index) => (
                  <tr key={role.id}>
                    <td>{index + 1}</td>
                    <td>{role.role_name}</td>
                    <td>{role.description}</td>
                    <td>
                      <span
                        className={`badge ${
                          role.status === "active"
                            ? "bg-success"
                            : "bg-danger"
                        }`}
                      >
                        {role.status}
                      </span>
                    </td>
                    <td>
                      <Link
                        to={`/roles/edit/${role.id}`}
                        className="btn btn-sm btn-warning me-2"
                      >
                        <RiEdit2Line />
                      </Link>
                      <button
                        className="btn btn-sm btn-danger"
                        onClick={() => handleDelete(role.id)}
                      >
                        <RiDeleteBin6Line />
                      </button>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default RoleListLayer;
